module.exports = __webpack_public_path__ + "img/sleeve ruffle length.173cd460.png";